import { render } from "./EliminarCuenta.vue?vue&type=template&id=204e6e22"
import script from "./EliminarCuenta.vue?vue&type=script&lang=js"
export * from "./EliminarCuenta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__